import { css } from '@emotion/react'
import { Card, font } from 'plume-ui'
import { OverseasCompanyData } from '../../../../../types/api'
import { CardTitle } from '../../../../atoms/CardTitle'
import { DescriptionList } from '../../../../atoms/DescriptionList'
import { DatasourceLink } from '../DatasourceLink'
import { DoubleColumnContent } from './DoubleColumnContent'
import { colors } from 'plume-ui'
import { formatDate } from '@/lib/date'
import { OverviewAmountWithCurrency } from './OverviewAmountWithCurrency'
import { toUnitNumber } from '@/lib/number'
import React from 'react'
import { SummaryLabelAnnotation } from '../domestic/CompanySummary'
import { FinanceInfoItem } from './FinanceInfoItem'

type Props = {
  company: OverseasCompanyData
}

export const OverseasIpoCompanyOverview: React.VFC<Props> = ({ company }) => {
  return (
    <div className="overview">
      <CardTitle
        right={
          <DatasourceLink
            href="https://help.initial.inc/ja/articles/5358443"
            className="about-data-source"
          />
        }
      >
        企業概要
      </CardTitle>
      <Card>
        <DoubleColumnContent>
          <DescriptionList
            list={{
              '国・地域': {
                text: company.country || '',
                extraClassName: 'country',
              },
            }}
          />
          <DescriptionList
            className="ipo-date company-type"
            list={{
              タイプ: { text: 'IPO企業', extraClassName: 'type' },
              IPO年月日: {
                text: company.ipo
                  ? formatDate(company.ipo?.date, 'yyyy/MM/dd')
                  : '',
                extraClassName: 'date',
              },
            }}
          />
        </DoubleColumnContent>
      </Card>
      <Card
        css={css`
          border-top: 1px solid ${colors.border};
          border-bottom: 1px solid ${colors.border};
        `}
      >
        <div
          css={css`
            padding: 32px;
          `}
        >
          <div
            className="ipo-valuation"
            css={css`
              width: 50%;
              display: flex;
            `}
          >
            <div
              css={css`
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                flex: 1;
              `}
            >
              <div
                css={css`
                  color: ${colors.black30};
                  font-weight: ${font.weight.bold};
                  margin-bottom: 12px;
                  font-size: 14px;
                `}
              >
                IPO時時価総額
                <br />
                <SummaryLabelAnnotation>（公開価格）</SummaryLabelAnnotation>
              </div>
            </div>
            <div
              css={css`
              display; flex;
              flex: 2;
              padding-left: 40px;
            `}
            >
              {company.ipo ? (
                <OverviewAmountWithCurrency
                  amount={
                    company.ipo.valuation.value
                      ? toUnitNumber(company.ipo?.valuation.value)
                      : null
                  }
                  currency={
                    company.ipo.valuation.currency
                      ? company.ipo.valuation.currency
                      : ''
                  }
                />
              ) : null}
            </div>
          </div>
          <div
            css={css`
              display: flex;
              justify-content: space-between;
            `}
          >
            <FinanceInfoItem
              className="total-funding"
              label={'総調達額'}
              value={
                <OverviewAmountWithCurrency
                  amount={
                    company.totalFundraise
                      ? toUnitNumber(company.totalFundraise.value)
                      : null
                  }
                  currency={
                    company.totalFundraise
                      ? company.totalFundraise.currency
                      : ''
                  }
                />
              }
              valueAnnotationDesc="最新対象ラウンド"
              valueAnnotationDate={
                company.totalFundraise && company.totalFundraise?.date
                  ? formatDate(company.totalFundraise.date, 'yyyy/MM/dd')
                  : null
              }
            />
          </div>
        </div>
      </Card>
    </div>
  )
}
